<template>
  <div id="naverIdLogin"></div>
</template>

<script>

import {initNaversdk} from '@/3rd_party/naver_oAuth.js'

export default {
  name: 'App',
  mounted() {
    initNaversdk();
  }
}
</script>
